import SearchService from '@/services/admin/SearchService'

export const namespaced = true

export const state = {
  results: {}
}

export const mutations = {
  SET_RESULTS(state, results) {
    state.results = results
  }
}

export const actions = {
  search({ commit }, query) {
    return new Promise((resolve, reject) => {
      SearchService.search(query)
        .then(response => {
          commit('SET_RESULTS', response)
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}
